// @flow
import { StyledMessage } from '@src/common-utils/styledComponents';
import { MessageHeader } from 'semantic-ui-react';
import React from 'react';

export const PositiveMessageWithHeaderText = ({ message, compact = false }) => {
  if (!message) {
    return null;
  }
  return (
    <StyledMessage compact={compact} positive={true}>
      <MessageHeader>{message}</MessageHeader>
    </StyledMessage>
  );
};
